(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rare-motion"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.rareGalleryMotion)window.rareGalleryMotion.destroy();
  const preference=window.matchMedia('(prefers-reduced-motion: reduce)');
  const active=new Map();
  const pending=new Set();
  const visited=new WeakSet();
  const listeners=new AbortController();
  let observer;
  const editor=window.Shopify&&window.Shopify.designMode;
  const selector='.section-head,.single-feature-image,.single-feature-copy,.feature-picture,.feature-copy,.topic,.portrait-frame,.dealer-copy,.collector-notes>div:first-child,.collector-notes details,.inquiry,.contact-grid>div,.grid>.card';
  function makeAvailable(element,remember){
    pending.delete(element);
    if(observer)observer.unobserve(element);
    element.dataset.motionState='settled';
    if(remember)visited.add(element);
    active.forEach((group,animation)=>{if(group===element){animation.cancel();active.delete(animation);}});
  }
  function restore(){
    if(observer){observer.disconnect();observer=null;}
    pending.forEach(element=>{element.dataset.motionState='available';});
    pending.clear();
    active.forEach((group,animation)=>{group.dataset.motionState='settled';animation.cancel();});
    active.clear();
  }
  function reveal(element){
    pending.delete(element);
    observer.unobserve(element);
    visited.add(element);
    element.dataset.motionState='revealing';
    if(preference.matches||editor||element.contains(document.activeElement)){makeAvailable(element,true);return;}
    const photograph=element.matches('.single-feature-image,.feature-picture,.portrait-frame');
    const parts=element.matches('.single-feature-copy,.feature-copy,.dealer-copy,.section-head,.inquiry')?Array.from(element.children):[element];
    const topic=element.matches('.topic');
    const baseDelay=topic?Array.from(element.parentElement.children).indexOf(element)*100:element.matches('.single-feature-copy,.feature-copy')?140:0;
    const animations=parts.map((part,index)=>{
      const animation=part.animate(
        [{opacity:0,translate:'0 '+(photograph?58:36)+'px'},{opacity:1,translate:'0 0'}],
        {duration:photograph?1100:850,delay:baseDelay+index*100,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'}
      );
      active.set(animation,element);
      return animation.finished.then(()=>active.delete(animation),()=>active.delete(animation));
    });
    Promise.all(animations).then(()=>{element.dataset.motionState='settled';});
  }
  function setup(root){
    if(preference.matches||editor||!('IntersectionObserver' in window)||typeof Element.prototype.animate!=='function')return;
    try{
      if(!observer)observer=new IntersectionObserver(entries=>{
        try{entries.forEach(entry=>{if(entry.isIntersecting&&pending.has(entry.target))reveal(entry.target);});}
        catch(error){restore();}
      },{threshold:0,rootMargin:'0px 0px -'+Math.round(window.innerHeight*.18)+'px 0px'});
      root.querySelectorAll(selector).forEach(element=>{
        if(visited.has(element)||pending.has(element))return;
        if(element.getBoundingClientRect().top<window.innerHeight||element.contains(document.activeElement)){makeAvailable(element,true);return;}
        observer.observe(element);
        pending.add(element);
        element.dataset.motionState='pending';
      });
    }catch(error){restore();}
  }
  preference.addEventListener('change',()=>{
    if(preference.matches)restore();
    else setup(document);
  },{signal:listeners.signal});
  document.addEventListener('focusin',event=>{
    pending.forEach(element=>{if(element.contains(event.target))makeAvailable(element,true);});
    active.forEach(group=>{if(group.contains(event.target))makeAvailable(group,true);});
  },{signal:listeners.signal});
  document.addEventListener('shopify:section:load',event=>setup(event.target),{signal:listeners.signal});
  document.addEventListener('shopify:section:unload',event=>{
    pending.forEach(element=>{if(event.target.contains(element))makeAvailable(element,false);});
    active.forEach(group=>{if(event.target.contains(group))makeAvailable(group,false);});
  },{signal:listeners.signal});
  let navigationTransition;
  window.addEventListener('pageswap',event=>{
    if(!event.viewTransition)return;
    const destination=event.activation&&event.activation.entry&&event.activation.entry.url;
    if(preference.matches||editor||!destination||!new URL(destination).pathname.startsWith('/products/'))event.viewTransition.skipTransition();
  },{signal:listeners.signal});
  window.addEventListener('pagereveal',event=>{
    navigationTransition=event.viewTransition;
    if(navigationTransition&&(preference.matches||editor||!location.pathname.startsWith('/products/')))navigationTransition.skipTransition();
  },{signal:listeners.signal});
  ['pointerdown','keydown'].forEach(name=>document.addEventListener(name,()=>{
    if(navigationTransition){navigationTransition.skipTransition();navigationTransition=null;}
  },{passive:true,signal:listeners.signal}));
  window.rareGalleryMotion={destroy(){restore();listeners.abort();}};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document),{once:true,signal:listeners.signal});
  else setup(document);
})();
  } catch(e) { console.error(e); }
})();

})();
